module.exports = __webpack_public_path__ + "media/images/athletes/1447-1631b1fe1b9054ea39a0a08e4ddee586.png";